<template>
  <!-- 添加标签弹框 -->
  <div class="small-dialog addTapPop-box" v-if="dialogVisable">
    <el-dialog
      :title="$t('User.ab')"
      :visible="dialogVisable"
      width="600px"
      custom-class="pop_dialog addTapPop-box_dialog"
      :append-to-body="true"
      @close="handleCloseTip()"
    >
      <div class="dialog-content">
        <div class="left-typeList tc">
          <div
            @click="handTypeTab(item, index)"
            :class="{ active: currentIndex == index }"
            class="itemOne"
            v-for="(item, index) in tagTypeList"
            :key="index"
          >
            {{ item.labeltype_name }}
            <template v-if="item.chooseNum > 0"
              >({{ item.chooseNum }})</template
            >
          </div>
        </div>
        <div class="right-tagList">
          <el-checkbox-group
            v-if="
              chooseTagList[currentIndex] &&
                tagList[currentIndex] &&
                tagList[currentIndex].list.length > 0
            "
            v-model="chooseTagList[currentIndex].list"
            class="list"
            @change="chooseTag(chooseTagList[currentIndex].list)"
          >
            <el-checkbox
              @change="changeCheckOne(item)"
              v-for="(item, index) in tagList[currentIndex].list"
              :key="index"
              :label="item.label_name"
              :disabled="!item.isCheck && checkList.length >= 3"
            >
              <div class="itemOne">
                {{ item.label_name }}
              </div>
            </el-checkbox>
          </el-checkbox-group>
          <div v-else class="empty-box">
            <p class="icon-empty"><i class="crm-wu"></i></p>
            <p>{{ errorTips }}</p>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="flex-al">
          <span v-if="checkList.length > 0" class="btn-clear" @click="handClear"
            >{{$t('components.User.addTapPop.604bris849s0')}}</span
          >
          <span v-else class="btn-clear"></span>
          <span v-if="checkList.length == 3" class="tipText"
            >{{$t('components.User.addTapPop.604bris87840')}}</span
          >
        </div>
        <div class="footer-btnBox">
          <el-button type="primary" size="mini" @click="handConfirm"
            >{{$t('components.User.addTapPop.604bris87h80')}}</el-button
          >
          <el-button size="mini" @click="handCancel">{{$t('components.User.addTapPop.604bris87mw0')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "addTapPop",
  props: [
    "dialogVisable",
    "defautLabelList",
    "clientId",
    "newclientTags",
    "labelType", // 学员标签对象类型
  ],
  components: {},
  data() {
    return {
      newid: [],
      newtestval: [],
      testval: [],
      currentIndex: 0, //当前的类型
      // 标签类型列表
      tagTypeList: [],
      // 标签列表
      tagList: [],
      allTagLabelList: [], //所有的label标签
      chooseTagList: [], //已选择的标签
      checkList: [], //选择的所有标签总和
      errorTips: this.$t('components.User.addTapPop.604bris87rg0'),
      newAry: [],
    };
  },
  mounted() {},
  updated() {},
  created() {
    this.getLabelApi();
  },
  computed: {},
  methods: {
    //获取客户标签-wgh
    getLabelApi() {
      this.$http
        .getLabelApi({
          client_id: this.clientId,
          labeltype_type: this.labelType,
        })
        .then((res) => {
          const { msg, data: _jb } = res.data;

          const data = _jb;
          let obj = {
            labeltype_name: this.$t("User.aa"),
            chooseNum: 0,
          };
          let commonList = [];
          data.list.label.forEach((v) => {
            commonList.push({
              label_name: v.label_name,
            });
          });
          this.tagTypeList = [];
          this.chooseTagList = [];
          this.tagList = [];
          const list = data.list.list ? data.list.list : [];
          if (list.length > 0) {
            list.forEach((e) => {
              e.chooseNum = 0;
              this.tagTypeList.push(e);
            });
            this.tagTypeList.unshift(obj);
          } else {
            this.tagTypeList = [obj];
          }
          this.allTagLabelList = commonList;
          this.tagTypeList.forEach((e, index) => {
            this.chooseTagList.push({
              list: [],
            });
            if (index == 0) {
              this.tagList.push({
                list: commonList,
              });
            } else {
              this.tagList.push({
                list: e.label,
              });
              this.allTagLabelList = [...this.allTagLabelList, ...e.label];
            }
          });
          if (this.defautLabelList.length > 0) {
            let arr = [];
            this.defautLabelList.forEach((e) => {
              arr.push(e);
            });
            this.dealTagList(arr); //处理标签数据
          }
          this.errorTips = msg;
        });
    },
    // 选择标签类型
    handTypeTab(item, index) {
      this.currentIndex = index;
    },
    //选择标签
    chooseTag(value) {
      console.warn(value);
      this.tagTypeList[this.currentIndex].chooseNum = value.length;
    },
    // 选择单个
    changeCheckOne(item) {
      let list = [];
      this.chooseTagList.forEach((e1) => {
        e1.list.forEach((e2, index2) => {
          if (e2 == item.label_name) {
            if (item.isCheck) {
              e1.list.splice(index2, 1);
            } else {
              list.push(e2);
            }
          } else {
            list.push(e2);
          }
        });
      });
      list = this.uniqArr(list);
      this.dealTagList(list);
    },
    // 处理标签数据
    dealTagList(list) {
      this.checkList = [];
      this.tagList.forEach((element, index) => {
        let chooseArr = [];
        this.tagTypeList[index].chooseNum = chooseArr.length;
        this.chooseTagList[index].list = chooseArr;
        element.list.forEach((e1) => {
          e1.isCheck = false;
          list.forEach((e2) => {
            if (e1.label_name == e2) {
              e1.isCheck = true;
              chooseArr.push(e2);
              chooseArr = this.uniqArr(chooseArr);
              this.tagTypeList[index].chooseNum = chooseArr.length;
              this.chooseTagList[index].list = chooseArr;
            }
          });
        });
        this.checkList = [...this.checkList, ...chooseArr];
      });
      this.checkList = this.uniqArr(this.checkList);
      (() => {})(this.tagTypeList, this.$t('components.User.addTapPop.604bris87ww0'));
    },
    // 清空所有选择
    handClear() {
      this.tagTypeList.forEach((e, index) => {
        (() => {})(e);
        e.chooseNum = 0;
        this.chooseTagList[index].list = [];
      });
      (() => {})(this.chooseTagList);
      this.checkList = [];
    },
    // 关闭弹框
    handleCloseTip() {
      this.$emit("handleCloseTip");
    },
    // 确定*****提交
    handConfirm() {
      if (this.checkList.length > 3) {
        this.$message.error(this.$t('components.User.addTapPop.604bris882k0'));
      } else {
        if (this.checkList.length) {
          let list = [];
          this.allTagLabelList.forEach((e1) => {
            this.checkList.forEach((e2) => {
              if (e1.label_name == e2 && !e1.is_select) {
                list.push(e1);
              }
            });
          });
          list = this.uniqArrKey(list, "label_name");
          this.$emit("handConfirm", list);
        } else {
          this.$message.error(this.$t('components.User.addTapPop.604bris88800'));
        }
      }
    },
    // 取消
    handCancel() {
      this.$emit("handCancel");
    },
    // 数组去重--一维数组
    uniqArr(arrList) {
      return Array.from(new Set(arrList));
    },
    // 数组去重--对象数组
    uniqArrKey(arrList, key) {
      let objItem = {},
        newAry = [];
      for (var i = 0; i < arrList.length; i++) {
        if (!objItem[arrList[i][key]]) {
          newAry.push(arrList[i]);
          objItem[arrList[i][key]] = true;
        }
      }
      return newAry;
    },
  },
};
</script>

<style lang="less">
.addTapPop-box_dialog {
  .el-dialog__footer {
    padding: 12px 20px;
    background: #f6f9fc;
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .btn-clear {
      color: #28abd9;
      font-size: 14px;
      cursor: pointer;
    }
    .tipText {
      margin-left: 20px;
      color: #d0021b;
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 0;
    .dialog-content {
      min-height: 300px;
      max-height: 500px;
      display: flex;
      .left-typeList {
        width: 150px;
        position: relative;
        .itemOne {
          font-size: 14px;
          color: #333333;
          padding: 12px 20px;
          text-align: center;
          cursor: pointer;
          &.active {
            color: #2aacd8;
            background: #e3f2fa;
            position: relative;
          }
          &.active::after {
            content: "";
            width: 1.5px;
            height: 100%;
            background: #2aacd8;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 10;
          }
        }
        &::after {
          content: "";
          width: 1px;
          height: 100%;
          background: #dddddd;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
      .right-tagList {
        flex: 1;
        overflow: scroll;

        color: #333;
        .list {
          padding: 10px 0 10px 20px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .el-checkbox {
            .el-checkbox__label {
              padding-left: 0;
            }
            .el-checkbox__input {
              display: none;
            }
          }
          .el-checkbox + .el-checkbox {
            margin-left: 0;
          }
          .itemOne {
            text-align: center;
            min-width: 80px;
            height: 28px;
            line-height: 28px;
            border-radius: 15px;
            color: #28abd9;
            font-size: 14px;
            padding: 0 18px;
            border: 1px solid #e3f2fa;
            margin-right: 20px;
            margin-bottom: 15px;
            cursor: pointer;
          }
          .is-checked {
            .itemOne {
              border: 1px solid #28abd9;
            }
          }
        }
        .empty-box {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img {
            width: 130px;
          }
          .icon-empty {
            margin-bottom: 30px;
            padding-left: 10px;
            i {
              font-size: 57px;
            }
          }
          p {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
